* {
    box-sizing: border-box;
}

img {
    max-width: 100%;
    height: auto;
}

.page-partners-partner {
    background: transparent url(../../assets/media/grey-bg_480px.svg) no-repeat 0% 0%;
    background-size: 25%;
    border-top: 1px solid#2222221F;
}

.partners-heading {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-flow: row wrap;
    -ms-flex-flow: row wrap;
    flex-flow: row wrap;
    align-items: center;

    .item-image {
        width: 50%;
        float: left;
        line-height: 0;
        text-align: center;
        padding: 120px 24px 16px 24px;

        .logoimg {
            max-height: 120px;
        }
    }

    .item-info {
        width: 50%;
        float: left;

        .item-info-inner {
            max-width: 640px;
            margin-left: auto;
            padding: 120px 72px 16px 16px;

            h1,
            h3 {
                font-size: 44px;
                line-height: 1.22;
                margin: 0 0 24px 0;
                color: #222;
            }

            p {
                margin: 0 0 16px 0;
                font-size: 18px;
                line-height: 1.5;
                color: #222;

                &:last-of-type {
                    margin-bottom: 0;
                }

                a {
                    color: #0076C0;
                    font-weight: 700;

                    &:hover {
                        text-decoration: underline;
                    }
                }
            }

            .item-link {
                position: relative;
                font-size: 18px;
                line-height: 1.5;
                display: inline-block;
                color: #0076C0;
                margin-top: 32px;
                font-weight: 700;
                border-bottom: 2px solid #0076C029;
                padding: 12px 40px 12px 0;
                box-sizing: border-box;

                &::after {
                    content: '';
                    position: absolute;
                    top: 50%;
                    transform: translatey(-50%);
                    right: 0;
                    width: 24px;
                    height: 24px;
                    background: transparent url(../../assets/icon/i_arrow.svg);
                }

                &:hover {
                    border-color: #0076C0;
                }
            }
        }
    }
}

.partners-services-wrapper {
    h2 {
        text-align: center;
        font-size: 44px;
        line-height: 1.22;
        font-weight: 700;
        margin: 0 0 32px 0;
        color: #222;
    }

    .partners-services-items {
        display: -webkit-box;
        display: -webkit-flex;
        display: -ms-flexbox;
        display: flex;
        -webkit-flex-flow: row wrap;
        -ms-flex-flow: row wrap;
        flex-flow: row wrap;
        margin-left: -16px;
        margin-right: -16px;

        .partners-services-item {
            width: 50%;
            float: left;
            padding-left: 16px;
            padding-right: 16px;

            .partners-services-item-inner {
                max-width: 544px;
                padding: 16px 24px 16px 0;

                h3 {
                    font-weight: 700;
                    font-size: 31px;
                    line-height: 1.3;
                    color: #222222;
                    margin: 0 0 24px 0;
                }

                p {
                    font-weight: 400;
                    font-size: 18px;
                    line-height: 1.5;
                    color: #222222;
                    margin: 0 0 16px 0;

                    &:last-of-type {
                        margin-bottom: 0;
                    }
                }
            }
        }
    }
}

@media (max-width: 1366px) {
    .partners-heading  {
        .item-info {
            .item-info-inner {
                h1,
                h3 {
                    font-size: 31px;
                    max-width: 340px;
                }
            }
        }
    }

    .partners-services-wrapper {
        h2 {
            font-size: 31px;
        }

        .partners-services-items {
            .partners-services-item {
                .partners-services-item-inner {
                    h3 {
                        font-size: 26px;
                    }
                }
            }
        }
    } 
}

@media (max-width: 1199px) {
    .partners-heading  {
        .item-info {
            .item-info-inner {
                padding: 96px 16px 16px 48px;
            }
        }

        .item-image {
            padding: 96px 24px 16px 24px;
        }
    }
}

@media (max-width: 995px) {
    .partners-heading {
        .item-info {
            .item-info-inner {
                padding: 64px 16px 16px 48px;

                h1,
                h3 {
                    font-size: 26px;
                    max-width: 340px;
                }

                p {
                    font-size: 16px;
                }

                .item-link {
                    font-size: 16px;
                    margin-top: 16px;
                }
            }
        }

        .item-image {
            padding: 64px 24px 16px 24px;
        }
    }

    .partners-services-wrapper {
        h2 {
            font-size: 26px;
        }

        .partners-services-items {
            margin-left: -8px;
            margin-right: -8px;

            .partners-services-item {
                padding-left: 8px;
                padding-right: 8px;

                .partners-services-item-inner {
                    h3 {
                        font-size: 22px;
                    }

                    p {
                        font-size: 16px;
                    }
                }
            }
        }
    } 
}

@media (max-width: 767px) {
    .partners-heading {
        .item-image {
            width: 100%;
            float: none;
            order: 1;
            padding: 48px 20px 0 20px;
        }

        .item-info {
            width: 100%;
            float: none;
            order: 2;

            .item-info-inner {
                padding: 48px 20px 0 20px;
            }
        }
    }
}

@media (max-width: 639px) {
    .partners-heading {
        .item-info {
            .item-info-inner {
                h1,
                h3 {
                    font-size: 22px;
                    max-width: 100%;
                }
            }
        }
    }

    .partners-services-wrapper {
        h2 {
            font-size: 22px;
            margin-bottom: 0;
        }

        .partners-services-items {
            .partners-services-item {
                width: 100%;
                float: none;

                .partners-services-item-inner {
                    max-width: 100%;
                    padding: 24px 0;

                    h3 {
                        font-size: 20px;
                        margin-bottom: 16px;
                    }
                }
            }
        }
    } 
}